import styled from "styled-components";

export const EmbedMediaLibraryWrapper = styled.div`
height:100vh; 
`
export const LandscapeIframe = styled.iframe`
  width: 1500px;
  height: 1080px;
  border: none;
  border-radius: 8px;
  transform: scale(0.208);
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 0;
`;